

export const RECIPE_COMPONENT_TYPE = {
    INGREDIENT: 0,
    QUESTION: 1,
    FOOD: 2
}